import { MenuItem } from '@mui/material'
import { TextInput } from '../../../../components/inputs/TextInput'
import { Text } from '../../../../components/typography'
import { intl } from '../../../../../i18n'
import { SprintSuffix } from './generateSprints'
import {
  ErrorText,
  FormLabel,
  FormRow,
  InputBox,
  NumberStepInput,
  StyledMuiSelect,
} from './formParts'
import {
  MAX_SERIAL_DIGITS,
  MAX_SERIAL_START,
  MIN_SERIAL_DIGITS,
  MIN_SERIAL_START,
  NamingRuleState,
  SUFFIX_TYPES,
} from './useNamingRule'

type Props = {
  labelId: string
  rule: NamingRuleState
  placeholder?: string
  error?: string
}

const NamingRuleFields = ({ labelId, rule, placeholder, error }: Props) => (
  <>
    <FormRow>
      <FormLabel>
        <Text variant="sBold">{intl.formatMessage({ id: labelId })}</Text>
      </FormLabel>
      <InputBox
        style={{ width: '150px', flexShrink: 0 }}
        className={error ? 'error' : undefined}
      >
        <TextInput
          value={rule.prefix}
          onChange={e => rule.setPrefix(e.target.value)}
          onFocus={e => e.target.select()}
          placeholder={placeholder}
          fullWidth={true}
        />
      </InputBox>
      <StyledMuiSelect
        value={rule.suffixType}
        onChange={e =>
          rule.setSuffixType(e.target.value as SprintSuffix['type'])
        }
        size="small"
      >
        {SUFFIX_TYPES.map(({ value, labelId: suffixLabelId }) => (
          <MenuItem key={value} value={value}>
            {intl.formatMessage({ id: suffixLabelId })}
          </MenuItem>
        ))}
      </StyledMuiSelect>
    </FormRow>

    {error && (
      <FormRow>
        <FormLabel />
        <ErrorText>
          <Text variant="2s">{error}</Text>
        </ErrorText>
      </FormRow>
    )}

    {rule.suffixType === 'serial' && (
      <FormRow>
        <FormLabel />
        <Text variant="s">
          {intl.formatMessage({ id: 'bulkSprint.serialStart' })}
        </Text>
        <NumberStepInput
          value={rule.serialStartInput}
          onChange={rule.setSerialStartInput}
          min={MIN_SERIAL_START}
          max={MAX_SERIAL_START}
        />
        <Text variant="s">
          {intl.formatMessage({ id: 'bulkSprint.serialDigits' })}
        </Text>
        <NumberStepInput
          value={rule.serialDigitsInput}
          onChange={rule.setSerialDigitsInput}
          min={MIN_SERIAL_DIGITS}
          max={MAX_SERIAL_DIGITS}
        />
      </FormRow>
    )}
  </>
)

export { NamingRuleFields }
